import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICreateEditAlertPayload } from "../../../common/types/alertsTypes";
import { Status } from "../../../common/constants";
import { createAlertUrl } from "../../../config";
import api from "../../../api";
import { IInitialSliceState } from "../../../common/types/commonTypes";

const CREATE_ALERT: string = "createAlert";

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  reqId: null,
  msg: null
};

interface ICreateAlertResponse {
  message: string;
}

export const createAlert = createAsyncThunk(
  CREATE_ALERT,
  async (payload: ICreateEditAlertPayload, { rejectWithValue }) => {
    try {
      const response = await api.post<ICreateAlertResponse>(
        createAlertUrl,
        payload
      );
      const createAlertResponse: ICreateAlertResponse = response.data;
      return createAlertResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const createAlertSlice = createSlice({
  name: CREATE_ALERT,
  initialState,
  reducers: {
    updateValue: (state, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAlert.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(createAlert.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
      })
      .addCase(createAlert.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Unknown error occurred";
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});
export const { updateValue } = createAlertSlice.actions;
export default createAlertSlice.reducer;
